import { get } from "lodash";
import { NODE_TYPES } from "utils/constants";
import {
  MAX_SILENT_PROCESSING_HOPS,
  isSilentProcessingNode,
} from "./paymentResume";

export const shouldPreviewOptimisticRun = (run) => {
  if (!run || isSilentProcessingNode(run)) return false;
  return get(run, "currentNode.nodeType") !== NODE_TYPES.AWAIT_PAYMENT;
};

export const hopPastSilentNodes = async ({
  run,
  moveForward,
  moveBack,
  direction = "forward",
  maxHops = MAX_SILENT_PROCESSING_HOPS,
}) => {
  let current = run;
  let hops = 0;
  while (isSilentProcessingNode(current) && hops < maxHops) {
    const mover = direction === "back" ? moveBack : moveForward;
    if (typeof mover !== "function") break;
    const next = await mover(current);
    if (!next || next === current) break;
    current = next;
    hops += 1;
  }
  return current;
};
